import { Box } from "@mui/material";
import Button from "../../toolkit/ButtonV1";
import PencilIcon from "../../icons/PencilIcon";
import TrashIcon from "../../icons/TrashIcon";
import { useEffect } from "react";

export default function EditCol(props) {
  useEffect(() => {
  }, [props]);
  return (
    <Box>
      {props.isEditable?.isVisible ? (
        <Button
          onClick={props.isEditable.callback}
          leadingComponent={<PencilIcon />}
          role="linkBlue"
          size="small"
        />
      ) : undefined}
      {props.isDeletable.isVisible ? (
        <Button
          onClick={props.isDeletable.callback}
          leadingComponent={<TrashIcon />}
          role="linkBlue"
          size="small"
        />
      ) : undefined}
    </Box>
  );
}
